import React from "react";
import { BtnProps, IconBtnProps } from "../../utils/types";
import { Icon } from "@iconify/react";
import { ClipLoader } from "react-spinners";
import ReactPaginate from "react-paginate";

const PrimaryBtn: React.FC<BtnProps> = ({
	text,
	width,
	onClick,
	loading,
	className,
	disabled,
	type,
	children,
}) => {
	return (
		<div>
			<button
				onClick={onClick}
				disabled={disabled || loading}
				type={type || "button"}
				style={{
					border: children ? "" : "1px solid #2070B8",
					boxShadow: children ? "" : "0px 1px 2px 0px #1018280D",
				}}
				className={`rounded-lg ${width || "w-72"} ${
					children
						? ""
						: `h-11 text-base font-medium capitalize
        flex items-center gap-3 justify-center`
				} ${className || "text-white bg-[#2070B8]"} ${
					(disabled || loading) && "cursor-not-allowed bg-opacity-40"
				}
        `}>
				{children || <span className="text-sm font-normal inter">{text}</span>}
				{loading && <ClipLoader color={"white"} size={16} />}
			</button>
		</div>
	);
};

export const IconButton: React.FC<IconBtnProps> = ({
  icon,
  text,
  onClick,
  bg,
  color,
  active,
  disabled,
}) => {
  return (
    <div>
      <button
        disabled={disabled}
        onClick={onClick}
        style={{
          color: color || "#344054",
          background: bg || "transparent",
          //   boxShadow: "0px 1px 2px 0px #1018280D",
        }}
        className={` ${
          active ? "btnshadow" : "shadow-sm shadow-[#1018280D]"
        } h-10 bg-transparent rounded-lg px-5 flex justify-center disabled:cursor-not-allowed text-sm font-normal items-center gap-2 border border-[#D0D5DD] `}
      >
        <Icon
          icon={icon}
          style={{
            fontSize: "24px",
          }}
          color={active ? "#2070B8" : color || "#344054"}
        />
        <span>{text}</span>
      </button>
    </div>
  );
};

export default PrimaryBtn;

type paginateType = {
  pageCount: number;
  handlePageClick: (e: any) => void;
};

export const MainPaginate = ({ handlePageClick, pageCount }: paginateType) => (
  <div className="flex justify-center items-center py-10">
    <ReactPaginate
      breakLabel="..."
      onPageChange={handlePageClick}
      pageRangeDisplayed={5}
      pageCount={pageCount}
      renderOnZeroPageCount={null}
      pageClassName="h-10 w-10 flex items-center justify-center rounded-full text-xl font-medium manrope border border-[#400167] text-[#400167] mx-2 cursor-pointer"
      className="flex items-center justify-center"
      previousClassName="hidden"
      nextClassName="hidden"
      activeClassName="bg-[#400167] text-white"
    />
  </div>
);

type loadMoreType = {
  next?: boolean;
  loading?: boolean;
  handleLoadMore?: () => any | undefined;
};

export const LoadMore = ({ handleLoadMore, next, loading }: loadMoreType) => {
  return (
    <>
      {!next ? (
        ""
      ) : (
        <PrimaryBtn
          onClick={handleLoadMore}
          text={loading ? "Loading..." : "Load More"}
          loading={loading}
          type={"button"}
        />
      )}
    </>
  );
};

export const Loaded = ({ color }: { color?: string }) => {
  return (
    <div className="fixed w-100 h-100 text-center loaded">
      <svg width="205" height="250" viewBox=" 0 0 40 50">
        <polygon
          stroke={color || "#22a6ac"}
          strokeWidth="1"
          fill="none"
          points="20,1 40,40 1, 40"
        />
      </svg>
    </div>
  );
};
